import { ChangeDetectorRef, Component } from '@angular/core';
import { Inspection } from '../../../shared/models/index';
import { PluginComponent } from '../../plugin.component';

@Component({
    templateUrl: './checked.component.html',
    standalone: false
})
export class InstallationCheckedPluginComponent {
  public checkedValues: any[];
  public config: any;
  public editRoute = ['installation', 'checked', 'edit'];

  constructor(private cdRef: ChangeDetectorRef) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  private initData() {
    this.checkedValues = this.config.CheckedValues;
  }
}
PluginComponent.plugins['installationchecked'] = InstallationCheckedPluginComponent;
